import { eDocumentErrorMessages } from '../../common/data';
import { getAlertMessageFunction, getDeleteDialogConfig } from '../../common/Util';

export const processHousingFundsStatus = (housingFundsCheckList, htm013) => {
  if (!housingFundsCheckList?.length) {
    return {};
  }

  const typeToKeyMap = {
    1: 'htm102',
    2: 'htm103',
    3: 'htm104',
    4: 'htm105',
  };

  //typeToKeyMap 값이 있으면 해당 값을 넣어준다.
  const newStatus = housingFundsCheckList.reduce((acc, item) => {
    const key = typeToKeyMap[item.hInType];
    if (key) {
      acc[key] = item.value;
    }
    return acc;
  }, {});

  return {
    htm013: htm013 || 0,
    ...newStatus,
  };
};

export const getEDocumentErrorMessages = (t, key) => {
  return eDocumentErrorMessages(t).find(item => item.key.includes(key)).label;
};
